import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import { actions as projectActions } from "store/actions";
import { scrollIntoView } from "utils/helper";

function UseUreedInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditUreed = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        ureedDetails: { ureedEmail: values?.ureed || undefined },
      };

      dispatch(
        projectActions.updateUreedCommon(payload, (ok, err) => {
          if (ok) {
            const updatedUser = {
              ...userDetails,
              bankDetails: {
                ...userDetails?.bankDetails,
                ureedEmail: values?.ureed || undefined,
              },
            };
            dispatch(actions.setUserDetails(updatedUser));
            notifySuccess("Has been updated successfully");
            scrollIntoView("ureedSection");
          } else {
            notifyError(
              err?.data?.error ?? err?.message ?? "Something went wrong!"
            );
          }
        })
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => () => {}, []);

  return { onEditUreed, isUreedLoading: isLoading };
}

export default UseUreedInformation;
